export default __webpack_public_path__ + "static/media/spiral-notebook-logo@2x.817574cf.png";